// @ts-check
import React, { StatelessComponent } from 'react'; // eslint-disable-line no-unused-vars
import PropTypes from 'prop-types';
import cx from 'classnames';

/** @typedef {{
  id?: string,
  children: JSX.Element | JSX.Element[],
  className?: string
}} RowPropsType */

/** @type { StatelessComponent<RowPropsType> } */
const Row = ({ id, children, className }) => (
  <div className={cx('row-fluid', className)} id={id}>
    {children}
  </div>
);

Row.displayName = 'Row';

Row.propTypes = {
  id: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
};

export default Row;
